import Vue from 'vue';
import ImageContent from './ImageContent/ImageContent.vue';
import VideoContent from './VideoContent/VideoContent.vue';
import ProductSelect from './ProductSelect/ProductSelect.vue';
import AreaSelect from './AreaSelect/AreaSelect.vue';
import SubmitButton from './SubmitButton/SubmitButton.vue';
import DescImage from './DescImage/DescImage.vue';
import CommonForm from './CommonForm/CommonForm.vue';
import NewForm from './NewFrom/NewFrom.vue';
import NewsForm from './NewsForm/NewsForm.vue';
import ServiceMonthForm from './ServiceMonthForm/ServiceMonthForm.vue';
import NewSelect from './NewSelect/NewSelect.vue';
import NewSubmitButton from './NewSubmitButton/NewSubmitButton.vue';
import QrCode from './QrCode/QrCode.vue';
import { Field, Checkbox, CheckboxGroup, CellGroup, Cell, Area, Popup, Button, RadioGroup, Radio } from 'vant';
import { Table, TableColumn, DatePicker, Pagination, Loading, Message, Form, FormItem, Input  } from 'element-ui'; // Button组件放到main.js里面引入了

// custom
Vue.component(ImageContent.name, ImageContent);
Vue.component(VideoContent.name, VideoContent);
Vue.component(ProductSelect.name, ProductSelect);
Vue.component(AreaSelect.name, AreaSelect);
Vue.component(SubmitButton.name, SubmitButton);
Vue.component(DescImage.name, DescImage);
Vue.component(CommonForm.name, CommonForm);
Vue.component(NewForm.name, NewForm);
Vue.component(NewsForm.name, NewsForm);
Vue.component(ServiceMonthForm.name, ServiceMonthForm)
Vue.component(NewSelect.name, NewSelect);
Vue.component(NewSubmitButton.name, NewSubmitButton);
Vue.component(QrCode.name, QrCode);

// vant
Vue.use(Field);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(Area);
Vue.use(Popup);
Vue.use(Button);
Vue.use(RadioGroup);
Vue.use(Radio)

// element
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
Vue.component(DatePicker.name, DatePicker);
Vue.component(Pagination.name, Pagination);
Vue.use(Loading.directive);
Vue.prototype.$message = Message;
Vue.component(Form.name, Form);
Vue.component(FormItem.name, FormItem);
Vue.component(Input.name, Input);
